import Controller from '@ember/controller'
import { action } from '@ember/object'
import { tracked } from '@glimmer/tracking'
import {
  serialize as serializeSort,
  deserialize as deserializeSort,
  updateSortColumns,
} from '@blakeelearning/data-tables/utils/sorting'

export default class extends Controller {
  queryParams = ['sort']

  @tracked sort = 'first_name'

  get sortingConfig() {
    return deserializeSort(this.sort)
  }

  set sortingConfig(newSortConfig) {
    this.sort = serializeSort(newSortConfig)
  }

  /**
   * This action should be called when a column is clicked, it sets the new sortingConfig for the URL query params
   */
  @action
  updateSorts({ sortKey }: SortObject) {
    if (sortKey) {
      const newSortConfig = updateSortColumns(this.sortingConfig, sortKey as string)
      this.sortingConfig = newSortConfig
    }
  }
}
